import type { TOC } from '@ember/component/template-only';

import TeamsIndexGridComponent from 'webapp/components/teams/index/grid';

const TeamsIndexRouteTemplate: TOC<object> = <template>
	<div id="page-teams" class="teams-page view-grid">
		<TeamsIndexGridComponent />
	</div>
</template>;

export default TeamsIndexRouteTemplate;
